<template>
    <div class="admin-pages">
        <PageTitle icon="fa fa-cogs" main="Adminstração do Sistema"
            sub="Cadastros \ Usuários \ Grupos \ Menus" />

        <div class="admin-pages-tabs">
            <b-card no-body>
                <b-tabs>                    
                    
                    <b-tab title="Menus" ><CategoryAdmin /></b-tab>
                    <b-tab title="Atualizações" ><ArticleAdmin /></b-tab>
                    
                    <b-tab title="Usuários" active><UserAdmin /></b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ArticleAdmin from './ArticleAdmin'
import CategoryAdmin from './CategoryAdmin'
import UserAdmin from './UserAdmin'

export default {
    name: 'AdminPages',    
    components: { PageTitle, ArticleAdmin, CategoryAdmin, UserAdmin }
}
</script>

<style>

</style>
